"use client"

import { usePathname, useRouter, useSearchParams } from "next/navigation"

export default function SortSelect({ value, hasQuery }: { value: string; hasQuery: boolean }) {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const options = [...(hasQuery ? [["relevance", "Best match"]] : []), ["title", "Name A–Z"], ["created_at", "Newest"]]
  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="text-elevate-grey-mid">Sort</span>
      <select
        value={value}
        onChange={(e) => {
          const p = new URLSearchParams(searchParams)
          p.set("sortBy", e.target.value)
          p.delete("page")
          router.push(`${pathname}?${p.toString()}`, { scroll: false })
        }}
        className="h-10 rounded-lg border border-elevate-border bg-white px-3"
      >
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </label>
  )
}
